import { since } from '../engine/version';
import { nameBlocked, nameError } from '../lib/names';
import { useBuffered } from '../components/useBuffered';
import { useGame, useS } from '../store/game';
import { Seg } from '../components/ui';
import { ColorPicker } from '../components/ColorPicker';
import { colorProblem } from '../engine/colors';
import { AX, AXN, QS, SCALE } from '../content/axes';
import { progFit, pub, scaleLabel } from '../engine/opinion';
import { Illu } from '../components/Illu';
import { AxGroups } from '../components/AxGroups';

export function Program({ next }: { next: () => void }) {
  const S = useS(); const { dispatch } = useGame();
  const hidePub = since(10); // Version 10: Vor der ersten Wahl keine Umfragen zu einzelnen Fragen
  const [name, setName, flushName] = useBuffered(S.name, (v: string) => dispatch('setName', v));
  const [color, setColor] = useBuffered(S.color || '#d6aa4e', (v: string) => { if (!colorProblem(v, 'YOU')) dispatch('setColor', v); });
  return (
    <section className="screen">
      <Illu src="/img/szene/programm.webp" className="illu scene" />
      <div><span className="label">September 2029 · Vor der Bundestagswahl</span><h2>Euer Wahlprogramm</h2></div>
      <p>Gib deiner Partei einen Namen und lege fest, wofür sie steht. An diesen Positionen messen euch später Koalitionspartner und eure eigenen Wähler. Je näher euer Programm an der Stimmung im Land liegt, desto mehr Stimmen bringt es.</p>
      {hidePub ? <p className="sub">Umfragen zu den einzelnen Fragen gibt es erst nach der ersten Wahl. Entscheidet nach eurer Überzeugung und eurem Gespür.</p> : <div className="kv"><span>Übereinstimmung mit der Bevölkerung</span><b className="num">{Math.round(progFit() * 100)} %</b></div>}
      <div className="param"><label className="label" htmlFor="pname">Name der Partei</label><input type="text" id="pname" maxLength={32} value={name} onChange={(e) => setName(e.target.value)} onBlur={flushName} /></div>
      {nameError(name, 'Dieser Parteiname') && <span className="sub down">{nameError(name, 'Dieser Parteiname')}</span>}
      <ColorPicker id="pcolor" value={color} onChange={setColor} abbr={name.slice(0, 3).toUpperCase()} skip="YOU" />
      <AxGroups render={(a: string) => (
        <div className="q" key={a}><span className="label">{AXN[a]}</span><p>{QS[a]}</p>
          <Seg value={S.you[a]} options={SCALE} onChange={(v) => dispatch('setProg', a, v)} />
          {!hidePub && <span className="sub">Stimmung in der Bevölkerung: {scaleLabel(pub(a))}</span>}</div>
      )} />
      <div className="actions"><button type="button" className="yes" disabled={nameBlocked(name)} onClick={() => { flushName(); next(); }}>Weiter: Schwierigkeit wählen</button></div>
    </section>
  );
}
